import AuditWorkflow from "@/pages/AuditWorkflow";
export default function DailyAudit() {
  return <AuditWorkflow auditType="Daily" />;
}
